import { render, staticRenderFns } from "./WarningMonitor.vue?vue&type=template&id=2f8a1ecb&scoped=true&"
import script from "./WarningMonitor.vue?vue&type=script&lang=js&"
export * from "./WarningMonitor.vue?vue&type=script&lang=js&"
import style0 from "./WarningMonitor.vue?vue&type=style&index=0&id=2f8a1ecb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a1ecb",
  null
  
)

export default component.exports